// Global
import React, { ReactNode } from 'react';

// Local
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import styles from '../CardListing.module.scss';
import { CtaFields, HeadlineFields } from 'lib/types/headlineFields';
import { Themes } from 'lib/themes';
import { Preamble, PreambleOrientation } from 'components/helpers/Molecules/Preamble/Preamble';
import clsx from 'clsx';

export interface MixedMediaGridProps extends HeadlineFields, CtaFields {
  theme?: Themes;
  numColumns?: '1' | '2' | '3' | '4';
  content?: ReactNode;
  preambleOrientation?: PreambleOrientation;
  centerLastRow?: boolean;
  constrainedComponentWidth?: boolean;
}
export const MixedMediaGrid = (props: MixedMediaGridProps) => {
  return (
    <BrandAndThemeProvider
      theme={props.theme}
      className={clsx(styles.contentGrid, styles[`col-${props.numColumns}`], {
        [styles.constrainedComponentWidth]: props.constrainedComponentWidth,
      })}
      data-component="authorable/shared/card-listing/mixedmediagrid/mixedmediagrid"
    >
      <Preamble
        headlineEyebrow={props.headlineEyebrow}
        headline={props.headline}
        headlineSubhead={props.headlineSubhead}
        headlineDescription={props.headlineDescription}
        cta1={props.cta1}
        cta2={props.cta2}
        align={props.preambleOrientation}
      >
        {props.content}
      </Preamble>
    </BrandAndThemeProvider>
  );
};
